import { createFileRoute } from '@tanstack/react-router';
import DocsGroupHome from '@/components/Docs/DocsGroupHome';

export const Route = createFileRoute('/developers/')({
  component: DevelopersHomePage,
});

function DevelopersHomePage() {
  return <DocsGroupHome group="developers" />;
}
